import { useQuery } from "react-query";
import API from "../api/phx";

/** Function to add some default config settings to each query */
const getDefaultConfig = (config) => {
  let queryConfig = config;
  return queryConfig;
};

const fetchCart = async () => {
  const res = await API.get(`/cart?view=website&extras=discounts,payment_methods,gift_cards`, { withCredentials: true });

  return res.data;
};

export const useCart = (config) => {
  const queryConfig = getDefaultConfig(config);
  return useQuery(["cart"], fetchCart, queryConfig);
};

export default useCart;
